import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ToastMessageService } from 'src/app/toastr.service';
import { environment } from 'src/environments/environment.prod';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LitigationComplaintsService } from '../components/litigation-complaints/litigation-complaints.service';

@Component({
  selector: 'app-get-most-searched',
  templateUrl: './get-most-searched.component.html',
  styleUrl: './get-most-searched.component.scss'
})
export class GetMostSearchedComponent {

  litigationData: any[] = [];
  filteredLitigationData: any[] = [];
  loading = true;
  selectedOption: string = ''; // Default to 'pdf'
  selectedUserOption: string = ''; // Default to 'pdf'

  isButtonDisabled: boolean = false;
  totalRecords: number = 0;
  currentPage: number = 1;
  pageSize: number = 10;
  dropdownOptions = [];
  dropdownUserOptions = [];
  displayDeleteDialog: boolean = false;
  recordToDelete: any;
  UserIp: any;
  email: any;
  selectedStatus: string | null = 'pending';
  selectedLitigationData: any[] = [];
  displayBulkRejectDialog: boolean = false;
  dateError: string = '';
  private searchSubject = new Subject<string>();

  private caseNumberSubject = new Subject<string>();
  private plaintiffSubject = new Subject<string>();
  private defendantSubject = new Subject<string>();
  private caseStatusSubject = new Subject<string>();
  private courtNameSubject = new Subject<string>();

  caseNumberSearch: string = '';
  plaintiffSearch: string = '';
  defendantSearch: string = '';
  courtNameSearch: string = '';

  searchTerm: string = '';

  constructor(private LitigationComplaintsService: LitigationComplaintsService, private toastService: ToastMessageService,
    private sanitized: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    this.getUserandCompanyData();
    this.searchSubject.pipe(
      debounceTime(400), // wait for typing to pause
      distinctUntilChanged()
    ).subscribe((search: any) => {
      if (search.length >= 3 || search.length === 0) {
        this.loadLitigationData(1, this.pageSize, search, this.selectedOption, this.selectedUserOption);
      }
    });
  }
  getUserandCompanyData() {

    this.loading = true;

    this.LitigationComplaintsService.getUserAndCompanyData(this.email).subscribe({
      next: (res: any) => {
        if (res?.companies?.length > 0) {
          this.dropdownOptions = [
            { label: 'Select Company', value: '' }, // First option
            ...res?.companies.map(item => ({
              label: item,
              value: item
            }))
          ];
        }
        if (res?.emails?.length > 0) {
          this.dropdownUserOptions = [
            { label: 'Select User', value: '' }, // First option
            ...res?.emails.map(item => ({
              label: item,
              value: item
            }))
          ];
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });

  }
  onSearchChange(value: string) {
    this.searchSubject.next(value.trim());
  }

  onCaseNumberChange(value: string) {
    this.caseNumberSubject.next(value.trim());
  }

  // onPlaintiffChange(value: string) {
  //   this.plaintiffSubject.next(value.trim());
  // }


  // onDefendantChange(value: string) {
  //   this.defendantSubject.next(value.trim());
  // }

  // onCourtNameChange(value: string) {
  //   this.courtNameSubject.next(value.trim());
  // }

  // onCaseStatusChange(value: string) {
  //   this.caseStatusSubject.next(value.trim());
  // }

  onOptionChange(event: any) {
    this.selectedOption = event.value;
    this.loadLitigationData(1, this.pageSize, this.searchTerm, this.selectedOption, this.selectedUserOption);
  }
  onOptionUserChange(event: any) {
    this.selectedUserOption = event.value;
    this.loadLitigationData(1, this.pageSize, this.searchTerm, this.selectedOption, this.selectedUserOption);
  }

  clearSearch() {
    this.selectedOption = '';
    this.selectedUserOption = '';
    this.loadLitigationData(1, this.pageSize, this.searchTerm, this.selectedOption, this.selectedUserOption);
  }

  openPdf(value) {
    let url: any = window.open(`${value}`);
    // let url: any = window.open(`http://3.111.249.237/pm_backend/${value}`);
    // let url: any = window.open(`http://3.111.95.5/pm_backend/${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }

  onClick(rowData) {
    console.log('1234', rowData);
    this.loading = true;
    this.LitigationComplaintsService.rerunlitigationLogic({
      "id": rowData?.id,
      "Case Number": rowData["Case Number"],
      "Plaintiff": rowData["Plaintiff"],
      "Defendant": rowData["Defendant"],
      "Filed Date": rowData["Filed Date"],
      "Court Name": rowData["Court Name"],
      "Judge": rowData["Judge"]
    }).subscribe({
      next: (res: any) => {
        this.loadLitigationData(this.currentPage, this.pageSize, this.searchTerm, this.selectedOption, this.selectedUserOption);
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  loadLitigationDataLazy(event: any) {
    this.loading = true;

    // const page = event.first / event.rows;
    // const size = event.rows;

    this.currentPage = Math.floor(event.first / event.rows) + 1;
    this.pageSize = event.rows;
    this.loadLitigationData(this.currentPage, this.pageSize, this.searchTerm, this.selectedOption, this.selectedUserOption);
  }

  loadLitigationData(page: number, size: number, search: string = '', filter_company: string = '', filter_email: string = '') {

    this.loading = true;

    this.LitigationComplaintsService.getMostSearcgProducts({
      user_email: this.email,
      page_number: page,
      per_page_record: size,
      search: search,
      filter_email: filter_email,
      filter_company: filter_company
    }).subscribe({
      next: (res: any) => {
        this.filteredLitigationData = res.data;
        this.totalRecords = res.total_records;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }



}

